<script>
    import _        from 'lodash'
    import * as api from '../../shared/api.js'
    import Modal    from '../../shared/SemanticModal.svelte'

    export let item
    export let active
    export let onAction
    
    let protocol = null
    let working  = false
    let error    = false

    function cancel() {
        protocol = null
        onAction(false)
    }

    function confirm() {

        working = true        
        const body = {
            id: item.protocol,
        }

        return api.post('/inquiry/execute', body)
            .then(api.toJsonIf200)
            .then(inquiry => {
                working  = false
                error    = false
                protocol = null
                onAction(inquiry)
            })
            .catch(err => {
                working = false
                error   = err
            })
    }

    function isReady(item, protocol) {
        return (item && protocol) ? protocol === item.protocol.substring(0, 5) : false
    }

    $: ready = isReady(item, protocol)
    $: icon = ready ? 'green check circle outline' : 'orange question circle outline'
</script>

<style>
    input {
        width: 160px;
    }
</style>

<Modal {active}>
    <div class="ui tiny modal visible active">
        <div class="header">
            Confirme a Execução
        </div>
        <div class="content">
            <h4>
                Digite os 5 primeiros números do protocolo do pedido <b>{ item.protocol }</b>
            </h4>        
            <div class="ui left aligned basic segment">
                <div class:disabled={working} class="ui right icon big input">
                    <input bind:value={ protocol } type="text" placeholder={item.protocol.substring(0, 5)}>
                    <i class="{icon} icon"></i>
                </div>            
            </div>
        </div>
        <div class="actions">
            <button class="ui black button" on:click={cancel}>
                Cancelar
            </button>
            <button class="ui green right labeled icon button"
                    class:disabled={working || !ready} 
                    class:loading={working} 
                    on:click={confirm}>
                Executar<i class="check icon"/>
            </button>
        </div>
    </div>
</Modal>